module.exports = __webpack_public_path__ + "static/media/og-agsus.f643de5c.png";